module.exports = __webpack_public_path__ + "static/media/usdt.350ee435.png";